<itfg-mi-report [client]="client"></itfg-mi-report>